import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-unauthorized-page',
    styles: [''],
    template: `
    <app-static-page-layout>
        <app-om-card>
            <app-om-card-header>
                <ng-container title>401 Not Authorized</ng-container>
            </app-om-card-header>
            <app-om-card-content>
                <p>It appears you are not authorized to view this page. Please contact your administrator if you think this is a mistake.</p>
                <button mat-raised-button color="primary" (click)="returnHome()"><mat-icon>home</mat-icon> Return Home</button>
            </app-om-card-content>
        </app-om-card>
    </app-static-page-layout>
    `,
    standalone: false
})
export class UnauthorizedPage {
    constructor(private router: Router) {}

    public returnHome(): void {
      this.router.navigateByUrl("app");
    }
}